





























import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

export default defineComponent({
    name: 'OddDirectionImg',
    inheritAttrs: false,
    functional: true,
    props: {
        oddDirection: {
            type: String as PropType<'up1' | 'up2' | 'down1' | 'down2'>,
            default: null,
        },
    },
});
